import React from "react";
import { Checkbox } from "@fluentui/react-components";
import { CodeBuilder } from "../MVCShared/CodeBuilder";
import { ChartAttr, Dependency, ValueTracker } from "../MVCShared/types";
import { Row } from "../../../components/Layout/Space";

type FacetSetup = {
  sharexVal: boolean | ValueTracker<boolean>;
  shareyVal: boolean | ValueTracker<boolean>;
  facetPalette: string | ValueTracker<string>;
  xlim: number | ValueTracker<number>;
  ylim: number | ValueTracker<number>;
  codeKey: string;
  onChangeSharex: (_, value) => void;
  onChangeSharey: (_, value) => void;
  codeRequiresInteraction?: boolean;
  visibleDependencies: Dependency[];
};
export function Facet(args: FacetSetup): ChartAttr {
  const {
    codeKey,
    sharexVal,
    shareyVal,
    facetPalette,
    xlim,
    ylim,
    onChangeSharex,
    onChangeSharey,
    codeRequiresInteraction,
    visibleDependencies,
  } = args;
  const shareXVal = sharexVal instanceof ValueTracker ? sharexVal.value : sharexVal;
  const shareYVal = shareyVal instanceof ValueTracker ? shareyVal.value : shareyVal;

  return {
    component: "Facet Grid",
    visibleDependencies: visibleDependencies || [],
    getReact: (labelWidth: number) => {
      return (
        <>
          <Row justifyContent="space-between">
            <label className="label" style={{ minWidth: labelWidth }}>
              Share X-Axis:
            </label>
            <Checkbox style={{ width: "100%" }} checked={shareXVal} onChange={onChangeSharex} data-testid="sharex" />
          </Row>
          <Row justifyContent="space-between">
            <label className="label" style={{ minWidth: labelWidth }}>
              Share Y-Axis:
            </label>
            <Checkbox style={{ width: "100%" }} checked={shareYVal} onChange={onChangeSharey} data-testid="sharey" />
          </Row>
        </>
      );
    },
    getCode: (code: CodeBuilder) => {
      let start = `${codeKey}=dict(`;
      let anyUpdated = false;

      if (codeRequiresInteraction) {
        const sxval: string = shareXVal ? "True" : "False";
        const syval: string = shareYVal ? "True" : "False";

        if (sharexVal instanceof ValueTracker && sharexVal.isUpdated) {
          start += `sharex=${sxval}, `;
          anyUpdated = true;
        }
        if (shareyVal instanceof ValueTracker && shareyVal.isUpdated) {
          start += `sharey=${syval}, `;
          anyUpdated = true;
        }
        if (facetPalette instanceof ValueTracker && facetPalette.isUpdated) {
          start += `palette='${facetPalette.value}', `;
          anyUpdated = true;
        }

        if (xlim instanceof ValueTracker && xlim.isUpdated) {
          start += `xlim=(0, ${xlim.value}), `;
          anyUpdated = true;
        }

        if (ylim instanceof ValueTracker && ylim.isUpdated) {
          start += `ylim=(0, ${ylim.value}), `;
          anyUpdated = true;
        }
      }
      if (anyUpdated) {
        start = start.slice(0, -2);
        start += `)`;
        code.plotAttrs.push(start);
      }
    },
  };
}
